import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  useUser,
  // useDb,
  useLang,
  useListSessionsWS,
  useListBoards,
  useListSails,
} from '../utils/hooks'
import CreateEmail from '../components/CreateEmail'
import CheckCode from '../components/CheckCode'
import CreateUserName from '../components/CreateUserName'
import CreatePwd from '../components/CreatePwd'
import Subscribe from '../components/Subscribe'
import DoDeleteSession from '../components/DoDeleteSession'
import { langLogin } from '../assets/langLogin'
import {
  freeAccount,
  subscribeAccount,
  oldSubscribeAccount,
} from '../assets/accounts'
import { useRef } from 'react'
import RemoveUserModal from '../components/RemoveUserModal'
import DoDeleteUser from '../components/DoDeleteUser'
import DoDeleteBoard from '../components/DoDeleteBoard'
import DoDeleteSail from '../components/DoDeleteSail'

const ModifyProfile = () => {
  const navigateTo = useNavigate()
  const firstDiv = useRef(null)

  const { user, changeUser } = useUser()
  // const { db } = useDb()
  const { lang } = useLang()
  const { listSessionsWS, setListSessionsWS } = useListSessionsWS()
  const { listBoards, setListBoards } = useListBoards()
  const { listSails, setListSails } = useListSails()
  const choosenLang = lang === 'fr' ? langLogin.fr : langLogin.eng

  const [email, setEmail] = useState(null)
  const [userName, setUserName] = useState(null)
  const [pwd, setPwd] = useState(null)

  const [code, setCode] = useState()
  const [codeId, setCodeId] = useState(null)

  const [emailModify, setEmailModify] = useState(false)
  const [userNameModify, setUserNameModify] = useState(false)
  const [pwdModify, setPwdModify] = useState(false)

  const [createEmail, setCreateEmail] = useState('')
  const [createPwd, setCreatePwd] = useState('')
  const [createUserName, setCreateUserName] = useState('')
  const [doSubscribe, setDoSubscribe] = useState(false)

  const [createEmailOK, setCreateEmailOK] = useState(false)
  const [createEmailNotUsed, setCreateEmailNotUsed] = useState(true)
  const [createUSerCodeExact, setCreateUserCodeExact] = useState(true)
  const [createUserCodeOK, setCreateUserCodeOK] = useState(false)
  const [createUserNameOK, setCreateUserNameOK] = useState(false)
  const [createPwdOK, setCreatePwdOK] = useState(false)
  const [subscribeOK, setSubscribeOK] = useState(-1)

  const [notifModificationEmail, setNotifModifcationEmail] = useState(false)
  const [notifModificationUserName, setNotifModifcationUserName] =
    useState(false)
  const [notifModificationPwd, setNotifModifcationPwd] = useState(false)

  const [showSubscribeNotif, setShowSubscribeNotif] = useState(false)

  const [removeUser, setRemoveUser] = useState({
    remove: false,
    userName: '',
    nbSessions: 0,
    nbBoards: 0,
    nbSails: 0,
  })

  const callApiDeleteCode = async () => {
    const url_code = '/api/code/deleteCode'
    fetch(url_code, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        codeId: codeId,
      }),
    })
      .then((response) => {
        response.json().then(() => {
          setCode()
          setCodeId(null)
        })
      })
      .catch((error) => console.log(error))
  }

  useEffect(() => {
    if (firstDiv.current !== null) {
      const topScroll = firstDiv.current.getBoundingClientRect().top
      window.scrollTo({ top: topScroll.current - 120, behavior: 'smooth' })
    }
  }, [])

  useEffect(() => {
    const callApiCheckEmailExists = () => {
      // let url
      // switch (db) {
      //   case 'local':
      //   case 'ovh':
      //     url = '/api/auth/login'
      //     break
      //   case 'mongo':
      //     url = '/api/authMD/checkEmailExists'
      //     break
      //   default:
      // }
      const url = '/api/authMD/checkEmailExists'
      fetch(url, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: createEmail,
        }),
      })
        .then((response) => {
          response.json().then((data) => {
            console.log(data)
            if (data.message) {
              if (data.message === 'no_user') {
                setCreateEmailOK(true)
                const url_code = '/api/code/setCode'
                fetch(url_code, {
                  method: 'post',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    email: createEmail,
                    what: 'updateEmail',
                    lang: lang,
                  }),
                })
                  .then((response) => {
                    response.json().then((data) => {
                      const temp_codeId = data.id
                      //const temp_code = data.code
                      //setCode(temp_code)
                      setCodeId(temp_codeId)
                    })
                  })
                  .catch((error) => console.log(error))
              } else {
                setCreateEmail('')
                setCreateEmailNotUsed(false)
              }
            }
          })
        })
        .catch((error) => console.log(error))
    }
    if (createEmail !== '') callApiCheckEmailExists()
  }, [createEmail])

  useEffect(() => {
    if (user.userId === -1) return
    const dc = decodeURIComponent(document.cookie)
    const sdc = dc.split('=')[1]
    const ws = sdc.split(';')[0]

    const url = '/api/authMD/getUserEmail'
    const data = { id: user.userId }

    fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        authorization: 'ws ' + ws,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        response.json().then((data) => {
          setEmail(data.email)
          setPwd('******')
          setUserName(user.userName)
        })
      })
      .catch((error) => console.log(error))
  }, [user])

  useEffect(() => {
    if (user.userId === -1) return
    if (createUserCodeOK === false) return
    setEmailModify(false)
    setCreateEmailOK(false)
    setCreateUserCodeOK(false)
    const dc = decodeURIComponent(document.cookie)
    const sdc = dc.split('=')[1]
    const ws = sdc.split(';')[0]

    const url = '/api/authMD/updateEmail'
    const data = { id: user.userId, email: createEmail }

    fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        authorization: 'ws ' + ws,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        console.log('mail modifié')
        setEmail(createEmail)

        setCreateEmail('')

        setCreateEmailNotUsed(true)
        setCreateUserCodeExact(true)
        setNotifModifcationEmail(true)
      })

      .catch((error) => console.log(error))
  }, [createUserCodeOK, user, createEmail])

  useEffect(() => {
    if (user.userId === -1) return
    if (createUserNameOK === false) return
    setUserNameModify(false)
    setCreateUserNameOK(false)
    const dc = decodeURIComponent(document.cookie)
    const sdc = dc.split('=')[1]
    const ws = sdc.split(';')[0]

    const url = '/api/authMD/updateUserName'
    const data = { id: user.userId, userName: createUserName }

    fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        authorization: 'ws ' + ws,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        console.log('userName modifié')
        setUserName(createUserName)
        changeUser({ ...user, userName: createUserName })
        localStorage.setItem('wsurf_userName', createUserName)
        setCreateUserName('')
        setNotifModifcationUserName(true)
      })

      .catch((error) => console.log(error))
  }, [createUserNameOK, user, createUserName])

  useEffect(() => {
    if (user.userId === -1) return
    if (createPwdOK === false) return
    setPwdModify(false)
    setCreatePwdOK(false)
    const dc = decodeURIComponent(document.cookie)
    const sdc = dc.split('=')[1]
    const ws = sdc.split(';')[0]

    const url = '/api/authMD/updatePwd'
    const data = { id: user.userId, pwd: createPwd }

    fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        authorization: 'ws ' + ws,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        console.log('pwd modifié')

        setCreatePwd('')
        setNotifModifcationPwd(true)
        /* changeUser({
          userName: '',
          userId: -1,
        }) */
      })

      .catch((error) => console.log(error))
  }, [createPwdOK, user, createPwd])

  useEffect(() => {
    const callApiUpdateSubscribe = async () => {
      const url = '/api/authMD/updateSubscribe'
      const start = new Date()
      fetch(url, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: user.userId,
          subscribeDate: start,
          subscribeLength: process.env.REACT_APP_SUBSCRIBE_LENGTH_MONTHS,
        }),
      })
        .then((response) => {
          response.json().then((data) => {
            /* console.log(data) */
            if (data.message) {
              if (data.message === 'abo ajoute') {
                const end = new Date(
                  start.setMonth(
                    start.getMonth() +
                      Number(process.env.REACT_APP_SUBSCRIBE_LENGTH_MONTHS),
                  ),
                )
                changeUser({
                  ...user,
                  accountType: subscribeAccount,
                  subscribeStart: start,
                  subscribeEnd: end,
                })
                localStorage.setItem('wsurf_accountType', subscribeAccount)
                localStorage.setItem('wsurf_subscribeStart', start)
                localStorage.setItem('wsurf_subscribeEnd', end)
              } else {
                //
              }
            }
          })
        })
        .catch((error) => console.log(error))
    }

    if (subscribeOK === 1) callApiUpdateSubscribe()
  }, [subscribeOK])

  // useEffect(() => {
  // const callApiGetSessionsForUser = async () => {
  //   const url = '/api/session/getSessionsForUser'
  //   const userId = { userId: user.userId }
  //   return new Promise((resolve, reject) => {
  //     fetch(url, {
  //       method: 'post',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(userId),
  //     })
  //       .then((response) => response.json())
  //       .then((sessions) => {
  //         resolve({ nbSessions: sessions.length })
  //       })
  //       .catch((error) => {
  //         console.log('Error getting sessions for user ' + userId, error)
  //         reject(error)
  //       })
  //   })
  // }

  // const callApiGetBoardsForUser = async () => {
  //   const url = '/api/board/getSessionsForUser'
  //   const userId = { userId: user.userId }
  //   return new Promise((resolve, reject) => {
  //     fetch(url, {
  //       method: 'post',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(userId),
  //     })
  //       .then((response) => response.json())
  //       .then((sessions) => {
  //         resolve({ nbSessions: sessions.length })
  //       })
  //       .catch((error) => {
  //         console.log('Error getting sessions for user ' + userId, error)
  //         reject(error)
  //       })
  //   })
  // }

  //   if (removeUser === false) return

  // }, [removeUser])

  const onConfirmEmail = (temp_email) => {
    setCreateEmail(temp_email)
  }
  const onConfirmCode = (temp_code) => {
    // if (Number(temp_code) === code) {
    //   setCreateUserCodeOK(true)
    // } else {
    //   setCreateUserCodeOK(false)
    //   setCreateUserCodeExact(false)
    //

    const url = '/api/code/verifyCode'
    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: codeId,
        code: temp_code,
      }),
    })
      .then((response) => {
        response.json().then((data) => {
          if (data.verify === true) {
            setCreateUserCodeOK(true)
            callApiDeleteCode()
          } else {
            setCreateUserCodeOK(false)
            setCreateUserCodeExact(false)
          }
        })
      })
      .catch((error) => console.log(error))
  }

  const onConfirmUserName = (temp_user_name) => {
    setCreateUserName(temp_user_name)
    setCreateUserNameOK(true)
  }

  const onConfirmPwd = (temp_pwd) => {
    setCreatePwd(temp_pwd)
    setCreatePwdOK(true)
  }

  const onConfirmSubscribe = (isOk) => {
    setDoSubscribe(false)
    setSubscribeOK(isOk)
  }

  const unsetNotifications = () => {
    setNotifModifcationEmail(false)
    setNotifModifcationUserName(false)
    setNotifModifcationPwd(false)
  }

  const handleModifyEmail = () => {
    unsetNotifications()
    setPwdModify(false)
    setUserNameModify(false)
    setEmailModify(true)
    setDoSubscribe(false)
  }

  const handleModifyUserName = () => {
    unsetNotifications()
    setPwdModify(false)
    setEmailModify(false)
    setUserNameModify(true)
    setDoSubscribe(false)
  }

  const handleModifyPwd = () => {
    unsetNotifications()
    setEmailModify(false)
    setUserNameModify(false)
    setPwdModify(true)
    setDoSubscribe(false)
  }

  const handleModifyAccountType = () => {
    unsetNotifications()
    setEmailModify(false)
    setUserNameModify(false)
    setPwdModify(false)
    setDoSubscribe(true)
  }

  const handleDeleteAccount = () => {
    setRemoveUser({
      remove: true,
      userName: user.userName,
      nbSessions: listSessionsWS.initialData.length,
      nbBoards: listBoards.initialData.length,
      nbSails: listSails.initialData.length,
    })
  }

  const handleCloseRemoveAccountModal = () => {
    setRemoveUser({
      remove: false,
      userName: '',
      nbSessions: 0,
      nbBoards: 0,
      nbSails: 0,
    })
  }

  const handleDoDeleteAccount = () => {
    const promises = listSessionsWS.initialData.map((session) =>
      DoDeleteSession(session),
    )
    Promise.all(promises)
      .then((sessionsRemoved) => {
        let userPromises = []
        listBoards.initialData.forEach((board) =>
          userPromises.push(DoDeleteBoard(board)),
        )
        listSails.initialData.forEach((sail) =>
          userPromises.push(DoDeleteSail(sail)),
        )
        userPromises.push(DoDeleteUser(user))
        Promise.all(userPromises)
          .then((userRemoved) => {
            setRemoveUser({
              remove: false,
              userName: '',
              nbSessions: 0,
              nbBoards: 0,
              nbSails: 0,
            })
            setListSessionsWS({ type: 'RESET_SESSIONS' })
            setListBoards({ type: 'RESET_BOARDS' })
            setListSails({ type: 'RESET_SAILS' })
            navigateTo('/login/')
          })
          .catch((error) => {
            console.log(error)
          })
      })
      .catch((error) => {
        if (error.result) {
          console.log(error.result)
          console.log(error.sessionId)
        }
      })
  }

  const handleCloseNotification = (origin) => {
    switch (origin) {
      case 'email':
        setNotifModifcationEmail(false)
        break
      case 'userName':
        setNotifModifcationUserName(false)
        break
      case 'pwd':
        setNotifModifcationPwd(false)
        break
      case 'subscribe':
        setSubscribeOK(-1)
        break

      default:
        break
    }
  }

  const onCancel = () => {
    setCreateEmail('')
    setEmailModify(false)
    setCreatePwd('')
    setCreateUserName('')
    setUserNameModify(false)
    setCreateEmailOK(false)
    setCreateEmailNotUsed(true)
    setCreateUserCodeExact(true)
    setCreateUserCodeOK(false)
    setCreateUserNameOK(false)
    setCreatePwdOK(false)
    setDoSubscribe(false)
    setPwdModify(false)
    setNotifModifcationEmail(false)
    setNotifModifcationUserName(false)
    setNotifModifcationPwd(false)
  }
  const th_class = 'has-text-weight-bold is-size-7-mobile'
  const td_class =
    (user.accountType === subscribeAccount
      ? 'has-text-info-dark is-size-7-mobile'
      : 'has-text-primary-dark') + ' has-text-weight-bold is-size-7-mobile'
  const btn_class =
    'button ' +
    (user.accountType === subscribeAccount ? 'is-info' : 'is-primary') +
    ' is-outlined is-size-7-mobile'

  return (
    <section className="section" ref={firstDiv}>
      <h1 className="title is-4 is-size-5-mobile">{choosenLang.profile}</h1>
      <div className="columns is-variable is-8">
        <div className="column is-one-third">
          <div className="block">
            <table className="table is-full-width">
              <tbody>
                <tr>
                  <th className={th_class}>{choosenLang.address}</th>
                  <td className={td_class}>{email}</td>
                  <td>
                    <button className={btn_class} onClick={handleModifyEmail}>
                      {choosenLang.modify}
                    </button>
                  </td>
                </tr>

                <tr>
                  <th className={th_class}>{choosenLang.userName}</th>
                  <td className={td_class}>{userName}</td>
                  <td>
                    <button
                      className={btn_class}
                      onClick={handleModifyUserName}
                    >
                      {choosenLang.modify}
                    </button>
                  </td>
                </tr>

                <tr>
                  <th className={th_class}>{choosenLang.pwd}</th>
                  <td className={td_class}>******</td>
                  <td>
                    <button className={btn_class} onClick={handleModifyPwd}>
                      {choosenLang.modify}
                    </button>
                  </td>
                </tr>
                <tr>
                  <th className={th_class}>
                    <div>{choosenLang.accountType}</div>
                  </th>
                  <td className={td_class}>
                    {user.accountType === freeAccount
                      ? choosenLang.freeAccount
                      : (user.accountType === oldSubscribeAccount
                          ? choosenLang.oldSubscribeAccount
                          : choosenLang.subscribeAccount) +
                        ' ' +
                        user.subscribeEnd.toLocaleDateString()}
                  </td>
                  <td>
                    {(user.accountType === freeAccount ||
                      user.accountType === oldSubscribeAccount) && (
                      <button
                        className={btn_class}
                        onClick={handleModifyAccountType}
                        onMouseEnter={() => setShowSubscribeNotif(true)}
                        onMouseLeave={() => setShowSubscribeNotif(false)}
                      >
                        {choosenLang.changeForSubscribe}
                      </button>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="block">
              {showSubscribeNotif && (
                <div className="notification is-info is-light is-size-7">
                  {choosenLang.subscribeDetail}
                </div>
              )}
            </div>
          </div>
          <br />
          <br />
          <div className="block">
            <button
              className="button is-danger is-outlined"
              onClick={handleDeleteAccount}
              disabled={
                emailModify === true ||
                userNameModify === true ||
                pwdModify === true
              }
            >
              {choosenLang.deleteAccount}
            </button>
          </div>
        </div>

        <div className="column is-one-third">
          <div className="content">
            {emailModify && !createEmailOK && (
              <CreateEmail
                doSubscribe={false}
                emailNotUsed={createEmailNotUsed}
                onConfirmEmail={onConfirmEmail}
                title={choosenLang.setNewAddress}
                pwdLostEmailExist={false}
                showCGU={false}
                onCancel={onCancel}
              />
            )}
            {createEmailOK && !createUserCodeOK && (
              <CheckCode
                doSubscribe={false}
                codeExact={createUSerCodeExact}
                onConfirmCode={onConfirmCode}
                mail={createEmail}
                onCancel={onCancel}
              />
            )}
            {userNameModify && !createUserNameOK && (
              <CreateUserName
                doSubscribe={false}
                onConfirmUserName={onConfirmUserName}
                onCancel={onCancel}
                title={choosenLang.setNewUsername}
              />
            )}
            {pwdModify && !createPwdOK && (
              <CreatePwd
                doSubscribe={false}
                onConfirmPwd={onConfirmPwd}
                onCancel={onCancel}
                title={choosenLang.setNewPwd}
              />
            )}
            {doSubscribe && (
              <>
                <h4 className="notification is-info is-light">
                  {choosenLang.doSubscribeTitle}
                </h4>
                <Subscribe
                  onConfirmSubscribe={onConfirmSubscribe}
                  onCancel={onCancel}
                />
              </>
            )}
            {notifModificationEmail && (
              <div className="notification">
                <button
                  className="delete"
                  onClick={() => handleCloseNotification('email')}
                ></button>
                {choosenLang.addressModified}
              </div>
            )}
            {notifModificationUserName && (
              <div className="notification">
                <button
                  className="delete"
                  onClick={() => handleCloseNotification('userName')}
                ></button>
                {choosenLang.userNameModified}
              </div>
            )}
            {notifModificationPwd && (
              <div className="notification">
                <button
                  className="delete"
                  onClick={() => handleCloseNotification('pwd')}
                ></button>
                {choosenLang.pwdModified}
              </div>
            )}
            {subscribeOK !== -1 && (
              <div
                className={
                  'notification ' +
                  (subscribeOK === 1 ? 'is-info is-light' : 'is-alert')
                }
              >
                <button
                  className="delete"
                  onClick={() => handleCloseNotification('subscribe')}
                ></button>
                {subscribeOK === 1
                  ? choosenLang.subscribeModified
                  : choosenLang.subscribeCanceled1}
              </div>
            )}
          </div>
        </div>
      </div>
      {removeUser.remove === true && (
        <>
          <RemoveUserModal
            options={removeUser}
            handleClose={handleCloseRemoveAccountModal}
            handleDoDelete={handleDoDeleteAccount}
          />
        </>
      )}
    </section>
  )
}

export default ModifyProfile
